import nativeMethodCalling from './nativeMethodCalling';

// eslint-disable-next-line require-jsdoc
const callNativeMethod = (data) => {
  nativeMethodCalling.postMessage(JSON.stringify(data));
};
export default callNativeMethod;
